// eslint-disable-next-line no-restricted-imports
import '@babel/runtime/regenerator';
import styled from '@emotion/native';
import { useTheme } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AbsoluteProvider } from 'design-system';
import { StatusBar } from 'expo-status-bar';
import { LiveDataProvider } from 'integration/live-vitals';
import { RootNavigator } from 'navigation/root-nav';
import {
  MeetingRoomDisplayProvider,
  MeetingRoomProvider,
} from 'providers/video';
import type React from 'react';
import 'react-native-gesture-handler';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SWRConfig } from 'swr';
import { queryClient, trpc, trpcClient } from 'trpc';

const swrConfig = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  refreshWhenOffline: false,
  refreshWhenHidden: false,
  refreshInterval: 0,
};

const StatusBarBackground = styled.View(({ theme }) => {
  const { top } = useSafeAreaInsets();

  return {
    height: top,
    backgroundColor:
      theme.name === 'dark' ? theme.color.black : theme.color.white,
  };
});

const ThemedStatusBar: React.FC = () => {
  const theme = useTheme();
  const statusBarStyle = theme.name === 'dark' ? 'light' : 'dark';
  return <StatusBar style={statusBarStyle} />;
};

export default function RootLayout() {
  return (
    <GestureHandlerRootView>
      <StatusBarBackground />
      <ThemedStatusBar />

      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <LiveDataProvider>
            <MeetingRoomProvider>
              <AbsoluteProvider>
                <SWRConfig value={swrConfig}>
                  <MeetingRoomDisplayProvider>
                    <RootNavigator />
                  </MeetingRoomDisplayProvider>
                </SWRConfig>
              </AbsoluteProvider>
            </MeetingRoomProvider>
          </LiveDataProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </GestureHandlerRootView>
  );
}
